export default __webpack_public_path__ + "static/media/dse-logo.fc38ebb6.webp";